import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { useBootstrapAuth } from '@/api/hooks/useAuth';
import { queryClient } from '@/lib/queryClient';

/**
 * 会话引导：应用启动时尝试用 HttpOnly 刷新 Cookie 恢复登录态。
 * 放在 Provider 内部（需要 QueryClient），且只在 `status === 'idle'` 时执行一次。
 */
function AuthBootstrap({ children }: { children: ReactNode }) {
  useBootstrapAuth();
  return <>{children}</>;
}

/**
 * 全局 Provider 装配。
 *
 * 目前只有 TanStack Query + 会话引导；批次 5-4 的 AppShell、批次 5-3 的路由
 * 都在 App 层组装，这里保持"与路由无关"的纯粹性。
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthBootstrap>{children}</AuthBootstrap>
    </QueryClientProvider>
  );
}
